import React, { useEffect, useState } from "react";
import { CONTROL } from "./ui";

/**
 * Whether the team is inside its working hours right now — a live dot rather
 * than a coloured block, so it reads as presence instead of an alert.
 */
const TimezoneInfo = ({ adminTimezone }) => {
    const [isOnline, setIsOnline] = useState(false);

    const isWithinWorkingHours = (timezone) => {
        const currentTime = new Date().toLocaleTimeString("en-US", {
            timeZone: timezone,
            hour12: false,
        });
        const [hour] = currentTime.split(":").map(Number);
        return hour >= 8 && hour < 24;
    };

    useEffect(() => {
        setIsOnline(isWithinWorkingHours(adminTimezone));
    }, [adminTimezone]);

    return (
        <div
            title={isOnline ? "Support is online" : "Outside working hours"}
            className={`hidden h-10 items-center gap-2 rounded-full border px-3 sm:flex ${CONTROL}`}
        >
            <span className="relative flex h-2 w-2">
                {isOnline ? (
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
                ) : null}
                <span
                    className={`relative inline-flex h-2 w-2 rounded-full ${
                        isOnline ? "bg-emerald-500" : "bg-rose-500"
                    }`}
                />
            </span>
            <span
                className={`text-xs font-bold uppercase tracking-[0.08em] ${
                    isOnline ? "text-emerald-600 dark:text-emerald-400" : "text-rose-600 dark:text-rose-400"
                }`}
            >
                {isOnline ? "online" : "offline"}
            </span>
        </div>
    );
};

export default TimezoneInfo;
